import { quizPhase, type QuizTiming } from './quizClock';

/** A quiz as the fan page receives it from get_fan_page_data ('quizzes'). Nothing secret in it. */
export interface FanQuiz extends QuizTiming {
  id: string;
  club_id: string;
  event_id: string | null;
  title: string;
  prize_text: string;
  /** The club's own words for the first screen, in its fans' language; null = the platform's default lines. */
  intro_text?: string | null;
  slot: 'pre_match' | 'half_time';
}

/** How long after the last reveal a finished quiz stays on the home list (rank and claim code reachable). */
export const QUIZ_RESULTS_LINGER_MS = 20 * 60_000;

/**
 * Which quizzes a fan may see: running ones, and ones finished within the
 * last 20 minutes. The club-level switch (club_settings.quiz_enabled) wins,
 * a missing flag counts as on (column default), like openPollsFor.
 */
export function fanQuizzes(quizzes: readonly FanQuiz[], quizEnabled: boolean | null | undefined, nowMs: number): FanQuiz[] {
  if (quizEnabled === false) return [];
  return quizzes.filter((q) => {
    if (q.status === 'running') return true;
    if (q.status !== 'finished' || !q.started_at) return false;
    const ends = Date.parse(q.started_at) + (q.intro_seconds + q.question_count * (3 + q.answer_seconds + q.reveal_seconds)) * 1000;
    return nowMs - ends < QUIZ_RESULTS_LINGER_MS;
  });
}

type Translate = (key: string, params?: Record<string, string>) => string;

/** The home-list button: the prize while it runs, "results" once it is over. */
export function quizButtonLabel(quiz: FanQuiz, nowMs: number, t: Translate): string {
  const over = quiz.status === 'finished' || quizPhase(quiz, nowMs).phase === 'finished';
  if (over) return t('quiz.buttonResults');
  return quiz.prize_text ? t('quiz.buttonLive', { prize: quiz.prize_text }) : t('quiz.button');
}

